module.exports = __webpack_public_path__ + "static/media/majorG1.0e7716c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorG1.wav
// module id = AYvt
// module chunks = 0